import dynamic from 'next/dynamic';

const MCPConnectPage = dynamic(() => import('../components/public-pages/MCPConnectPage'), {
  ssr: false,
});

export default function MCPConnect() {
  return <MCPConnectPage />;
}
